import { defineCustomElement, getBooleanAttribute, isAttrEqual, isAttrTrue, NectaryElement, updateBooleanAttribute } from '../utils';
const templateHTML = '<style>:host{display:table-row;background-color:var(--sinch-comp-table-color-row-default-background-initial)}:host([selected]){background-color:var(--sinch-comp-table-color-row-checked-background-initial)}:host(:hover){background-color:var(--sinch-comp-table-color-row-default-background-hover)}:host([sticky]) ::slotted(sinch-table-head-cell){position:sticky;top:0;z-index:1;background-color:var(--sinch-comp-table-color-row-default-background-sticky)}:host(:last-child) ::slotted(sinch-table-cell){border-bottom:none}</style><slot></slot>';
const template = document.createElement('template');
template.innerHTML = templateHTML;
defineCustomElement('sinch-table-row', class extends NectaryElement {
  constructor() {
    super();
    const shadowRoot = this.attachShadow();
    shadowRoot.appendChild(template.content.cloneNode(true));
  }
  connectedCallback() {
    this.setAttribute('role', 'row');
  }
  static get observedAttributes() {
    return ['sticky', 'selected'];
  }
  attributeChangedCallback(name, oldVal, newVal) {
    if (isAttrEqual(oldVal, newVal)) {
      return;
    }
    switch (name) {
      case 'sticky':
      case 'selected':
        {
          updateBooleanAttribute(this, name, isAttrTrue(newVal));
          break;
        }
    }
  }
  set sticky(isSticky) {
    updateBooleanAttribute(this, 'sticky', isSticky);
  }
  get sticky() {
    return getBooleanAttribute(this, 'sticky');
  }
  set selected(isSelected) {
    updateBooleanAttribute(this, 'selected', isSelected);
  }
  get selected() {
    return getBooleanAttribute(this, 'selected');
  }
});